import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Header from '@/components/shared/Header';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Page not found · Vesta CFO';
    console.error('404 Error: User attempted to access non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-vesta-mist/60 to-white">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="text-center max-w-md">
          <p className="text-sm font-mono uppercase tracking-widest text-vesta-gold mb-3">404</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-vesta-navy font-normal mb-4">
            Page not found
          </h1>
          <p className="text-vesta-navy/75 mb-8 leading-relaxed">
            We couldn&apos;t find <span className="font-mono text-sm text-vesta-navy/90">{location.pathname}</span>.
            The link may be outdated or the page may have moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild className="bg-vesta-navy hover:bg-vesta-navy-muted text-white gap-2">
              <Link to="/">
                <Home className="w-4 h-4" />
                Back to home
              </Link>
            </Button>
            <Button asChild variant="outline" className="border-vesta-navy/15 text-vesta-navy gap-2">
              <Link to="/contact">
                <ArrowLeft className="w-4 h-4" />
                Contact us
              </Link>
            </Button>
          </div>
        </div>
      </main>
      <SiteFooter variant="light" />
    </div>
  );
};

export default NotFound;
